import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Slide from '@mui/material/Slide';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import Button from '@mui/material/Button';
import CustomerOrder from '../CustomerOrder';
import PickupWizard from '../PickupWizard/PickupWizard.jsx';
import Drawer from '@mui/material/Drawer';

import CameraAltIcon from '@mui/icons-material/CameraAlt';

export default function MyOrder(props) {
    const [orders, setOrders] = React.useState([]);
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [previousOrder, setPreviousOrder] = React.useState(null); // toggles the pickup wizard component
    const [showNewOrderSlide, setShowNewOrderSlide] = React.useState(false); // toggles the pickup wizard component
    const [isFetchingModal, setIsFetchingModal] = React.useState(true);
    React.useEffect(() => {
        loadOrder(); // only called once
    }, []);

    function loadOrder() {
        setIsFetching(true);
    
        TokenService.customerPost('', 'MyOrders')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);

                    setOrders(JSON.parse(jsonData.Orders));

                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function startNewOrderClicked() {
        setIsFetchingModal(true);
        setPreviousOrder(null);
        setShowNewOrderSlide(true);
        TokenService.customerPost('', 'PreviousOrder')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);

                    let order = JSON.parse(jsonData.Order);
                    let client = JSON.parse(jsonData.Client);

                    setPreviousOrder(order);

                    window.setTimeout(function () {
                      
                    }, 200);
                    setIsFetchingModal(false);
                    
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildOrders() {
        if (orders.length == 0) {
            return (<div>
                <div>You do not have any open orders.</div>
                <div style={{ marginTop: '15px' }}><Button variant='contained' color="sipzeeGreen" onClick={() => startNewOrderClicked() }>Start New Order</Button></div>
            </div>
            )
        }
        else {
            return (<div>
                {orders.length == 1 ?
                    <CustomerOrder order={orders[0]} onCancelled={(order) => handleOnOrderCancelled(order)} />
                    :
                    <>
                    <div>Multiple orders not yet implemented</div>
                    <div><CustomerOrder order={orders[0]} onCancelled={(order) => handleOnOrderCancelled(order)} /></div>
                    </>
                }
            </div>)
        }

    }

    function handleOnOrderCancelled(order) {
        let tempOrders = [];
        for (let i = 0; i < orders.length; i++) {
            if (orders[i].RequestID != order.RequestID) {
                tempOrders.push(orders[i]);
            }
        }
        setOrders(tempOrders);
    }

    function handleSliderClosed() {
        setIsFetchingModal(false);
        setShowNewOrderSlide(false);
    }

    function handleCreateOrder(order, requestSameRecycler) {
        if (order !== null) {
            setIsFetchingModal(true);

            //if (order.Returnable_Type_Container_Detail_JSON != '') {
            //    order.Returnable_Type_Container_Detail_JSON = JSON.stringify(order.Returnable_Type_Container_Detail_JSON);
            //}

            let postData = {
                order: JSON.stringify(order),
                requestSameRecycler: requestSameRecycler
             }

            TokenService.customerPost(postData, 'CreateOrder')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);

                        setOrders(JSON.parse(jsonData.Orders));

                        handleSliderClosed();

                        enqueueSnackbar('Your order has been created', {
                            variant: 'success',
                        });
                    }
                    else {
                        // errors?
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                        setIsFetchingModal(false);
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    setIsFetchingModal(false);
                });
        }
    }

    return (<div>
        {isFetching ? buildSkeleton() :
            buildOrders()
        }
        <Drawer anchor='bottom' open={showNewOrderSlide} style={{ height: '90vh', width: '100%' }}>
        
            <div style={{ height: '90vh', width: '100%', backgroundColor:'#f5f5f5' }}>
                <div style={{ padding: '5px', display: 'flex', justifyContent: 'flex-end', backgroundColor:'var(--sipzee-gray-2)' }}>
                        <Button variant={'outlined'} style={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => handleSliderClosed()} >Cancel</Button>    
                    </div>
                {previousOrder == null || isFetchingModal ? 
                    buildSkeleton()
                    :
                    <div>
                        <div style={{ textAlign: 'center', fontSize: '14pt', marginTop: '5px', marginLeft:'10px', marginRight:'10px' }}>Below is a copy of your most recent order.</div>
                        <div style={{ textAlign: 'center', fontSize: '14pt', marginTop: '5px', marginLeft: '10px', marginRight: '10px' }}>Please review it and click the Create button to submit.</div>
                        <Paper style={{ padding: '3px', marginTop: '5px',marginBottom:'5px', paddingLeft:'5px', marginLeft:'auto', marginRight:'auto', maxWidth:'400px' }}>
                            <div style={{ display: 'flex', lineHeight:'50px' }}>
                                <img src={'/images/payout.png'} style={{ alignSelf: 'center',  width: '35px' }} />
                                <div style={{ marginLeft: '10px', alignSelf: 'center' }}>Adjust the Quantity in the Financials section</div>
                            </div>

                            <div style={{ display: 'flex', lineHeight: '50px' }}>
                                <CameraAltIcon style={{ alignSelf: 'center', fontSize: '30px', color: 'var(--sipzee-green)' }} />
                                <div style={{ marginLeft: '10px', alignSelf: 'center' }}>Update any Photos</div>
                            </div>
                            <div style={{ display: 'flex', lineHeight: '50px' }}>
                                <img src={'/images/recyclericon.svg'} style={{ alignSelf: 'center', height:'35px', width:'35px' }} />
                                <div style={{ marginLeft: '10px', alignSelf: 'center' }}>Request the same recycler?</div>
                            </div>
                        </Paper>
                      
                        <CustomerOrder order={previousOrder} createFromExisting={true} onCreateOrder={(order, requestSameRecycler) => handleCreateOrder(order, requestSameRecycler)} />
                    </div>
                }
                </div>
        
        </Drawer>
        
    </div>)
}